import ProcessDetailsPage from './pages/ProcessDetails.page';

ProcessDetailsPage.path = '/(containers|trailers)/:id/_details';

export default {
  pages: {
    ProcessDetailsPage,
  }
};
